import React from 'react'

import ImageAsset from '@components/image_asset'
import Link from '@components/link'
import Markdown from '@components/markdown'
import styles from '@components/blocks/testimonials_block.module.scss'
import ctaStyles from '@components/blocks/cta_block.module.scss'
import TestimonialsResponsiveContent from '@components/blocks/testimonials_responsive_content'

const TestimonialsBlock = React.forwardRef(({ fields }, _) => {
  const testimonials = fields.testimonials

  const testimonialBlocks = {}
  testimonials.forEach(testimonial => {
    testimonialBlocks[testimonial.id] = (
      <Testimonial key={testimonial.id} testimonial={testimonial} />
    )
  })

  const cta = fields.cta
  const ctaText = cta.fields.ctaText
  const ctaDataAttrs = {
    'data-link-type': 'cta',
    'data-link-name': ctaText,
  }

  return (
    <div className={styles.testimonials_block}>
      <div>
        <h2 className={styles.testimonials_block__title}>{fields.title}</h2>
        <p className={styles.testimonials_block__subtitle}>{fields.subtitle}</p>
      </div>
      <TestimonialsResponsiveContent
        testimonialBlocks={testimonialBlocks}
        testimonials={testimonials}
      />
      <div>
        <Link path={cta.fields.ctaPath} className={ctaStyles.ctaBlock__cta} {...ctaDataAttrs}>
          {ctaText}
        </Link>
      </div>
    </div>
  )
})

const Testimonial = React.forwardRef(({ testimonial }, ref) => (
  <div className={styles.testimonials_block__testimonial} ref={ref}>
    <div className={styles.testimonials_block__testimonial_text}>
      <Markdown className={styles.testimonials_block__testimonial_description}>
        {testimonial.fields.description}
      </Markdown>
      <div className={styles.testimonials_block__testimonial_quote}>{testimonial.fields.quote}</div>
      <div className={styles.testimonials_block__testimonial_quote_attribution}>
        {testimonial.fields.quoteAttribution}
      </div>
    </div>
    <div className={styles.testimonials_block__testimonial_image}>
      <ImageAsset asset={testimonial.fields.image} width="280" />
    </div>
    <div className={styles.testimonials_block__testimonial_title}>{testimonial.fields.title}</div>
  </div>
))

export default TestimonialsBlock
